import React, { useState } from 'react';
import SendNotification from '../faculty/SendNotification';
import NotificationsInbox from '../faculty/NotificationsInbox';
import Messages from '../faculty/Messages';
import './FacultyCommunication.css';

/**
 * Faculty Communication Module Wrapper
 * Integrates: Send Notifications, Notifications Inbox, Messages
 */
export default function FacultyCommunication({ facultyId, facultyName }) {
  const [activeTab, setActiveTab] = useState('send');

  return (
    <div className="faculty-comm-wrapper">
      <div className="comm-tabs">
        <button
          className={`comm-tab ${activeTab === 'send' ? 'active' : ''}`}
          onClick={() => setActiveTab('send')}
        >
          📢 Send Notification
        </button>
        <button
          className={`comm-tab ${activeTab === 'inbox' ? 'active' : ''}`}
          onClick={() => setActiveTab('inbox')}
        >
          📬 Notifications Inbox
        </button>
        <button
          className={`comm-tab ${activeTab === 'messages' ? 'active' : ''}`}
          onClick={() => setActiveTab('messages')}
        >
          💬 Messages
        </button>
      </div>

      <div className="comm-content">
        {activeTab === 'send' && (
          <SendNotification facultyId={facultyId} onClose={() => setActiveTab('inbox')} />
        )}
        {activeTab === 'inbox' && (
          <NotificationsInbox facultyId={facultyId} />
        )}
        {activeTab === 'messages' && (
          <Messages facultyId={facultyId} facultyName={facultyName} />
        )}
      </div>
    </div>
  );
}
